import { getAllEmployees } from "./getAllEmployees";

/**
 * Fetches the department for a user by email from BigQuery (directory_employees via devfolio API).
 * @param {string} userEmail - The user's email address
 * @returns {Promise<{ok: boolean, department: string|null}>}
 */
export async function getDepartmentByEmail(userEmail) {
  try {
    if (!userEmail || typeof userEmail !== "string") {
      return { ok: false, department: null };
    }
    const normalizedEmail = (userEmail || "").toLowerCase().trim();
    const emailPrefix = normalizedEmail.split("@")[0];

    const result = await getAllEmployees();
    if (!result.ok || !Array.isArray(result.employees)) {
      return { ok: true, department: null };
    }

    const exact = result.employees.find(
      (emp) => (emp.email || "").toLowerCase().trim() === normalizedEmail
    );
    if (exact) {
      const dept =
        exact.department && typeof exact.department === "string"
          ? exact.department.trim()
          : null;
      return { ok: true, department: dept };
    }

    const byPrefix = result.employees.find((emp) => {
      const e = (emp.email || "").toLowerCase().trim();
      return e && e.split("@")[0] === emailPrefix;
    });
    if (byPrefix) {
      const dept =
        byPrefix.department && typeof byPrefix.department === "string"
          ? byPrefix.department.trim()
          : null;
      return { ok: true, department: dept };
    }

    return { ok: true, department: null };
  } catch (err) {
    console.error("Error fetching department by email:", err);
    return { ok: false, department: null };
  }
}
